import { asNullableMeasure, asNullableSiValue, type Measure, type SiValue, type Stored } from "lab-testing-units";
import { asFurtherDryingContract, type FurtherDryingContract } from "./FurtherDryingContract";
import { WATER_CONTENT_MASS } from "./units";

export interface WaterContentContract {
  balance: string | null;
  container: string | null;
  containerMass: Measure | null;
  wetSoilContainerMass: Measure | null;
  oven: string | null;
  dryingMethod: string | null;
  dryingStartAt: string | null;
  dryingEndAt: string | null;
  drySoilContainerMass: Measure | null;
  constantMassMethod: string | null;
  furtherDryings: FurtherDryingContract[];
  readonly initialWetMass: SiValue | null;
  readonly massOfWater: SiValue | null;
  readonly totalDryMass: SiValue | null;
  readonly waterContent: number | null;
  readonly finalDrySoilContainerMass: Measure | null;
  readonly finalDryingEndAt: string | null;
  readonly dryMassChangePercent: number | null;
}

export const asWaterContentContract = (raw: unknown): WaterContentContract => {
  const stored = raw as Stored<WaterContentContract>;
  return {
    ...stored,
    containerMass: asNullableMeasure(stored?.containerMass, WATER_CONTENT_MASS),
    wetSoilContainerMass: asNullableMeasure(stored?.wetSoilContainerMass, WATER_CONTENT_MASS),
    drySoilContainerMass: asNullableMeasure(stored?.drySoilContainerMass, WATER_CONTENT_MASS),
    constantMassMethod: stored?.constantMassMethod ?? null,
    furtherDryings: stored?.furtherDryings?.map(asFurtherDryingContract) ?? [],
    initialWetMass: asNullableSiValue(stored?.initialWetMass, WATER_CONTENT_MASS),
    massOfWater: asNullableSiValue(stored?.massOfWater, WATER_CONTENT_MASS),
    totalDryMass: asNullableSiValue(stored?.totalDryMass, WATER_CONTENT_MASS),
    finalDrySoilContainerMass: asNullableMeasure(stored?.finalDrySoilContainerMass, WATER_CONTENT_MASS),
  };
};

export const asNullableWaterContentContract = (raw: unknown): WaterContentContract | null =>
  raw == null ? null : asWaterContentContract(raw);
